import { render, staticRenderFns } from "./MedicalExams.vue?vue&type=template&id=09f34d07&"
import script from "./MedicalExams.vue?vue&type=script&lang=js&"
export * from "./MedicalExams.vue?vue&type=script&lang=js&"
import style0 from "./MedicalExams.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports